import React from 'react';

import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";

import Layout from "./components/Layout";
import MembershipFormPage from "./pages/MembershipForm";
import MembershipConfirmationPage from "./pages/MembershipConfirmationPage";

import './App.css';
import ErrorPage from "./pages/Error";


function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<MembershipFormPage />} />
                    <Route path="confirmation" element={<MembershipConfirmationPage />} />
                    <Route path="error/:errorType" element={<ErrorPage />} />
                    <Route path='*' element={<Navigate to='/error/notFoundPage' />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
